import { render, staticRenderFns } from "./RegistrationTypeSetting.vue?vue&type=template&id=6c702a40"
import script from "./RegistrationTypeSetting.vue?vue&type=script&lang=js"
export * from "./RegistrationTypeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports